// src/features/counter/routes.js
export default [
  {
    path: 'counter',
    name: 'counter',
    component: () => import('./views/CounterView.vue'),
    meta: { 
      requiresAuth: true,
      title: 'Counter' ,
      menuResource: 'INGRESO_COUNTER'
    },
  },
]